import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material'
import { Controller, FormProvider, set, useForm, useFormContext, useWatch } from 'react-hook-form'
import { useEffect, useState } from 'react'
import TranslationsTable from '../../ui/TranslationsTable/TranslationsTable'
import { Category } from '../../types'

type CategoryFormProps = {
  restaurant: any
}

function CategoryForm({ restaurant }: CategoryFormProps) {
  const {
    register,
    formState: { errors },
    control,
    watch,
    unregister,
    handleSubmit,
    reset,
    setValue,
    getValues,
  } = useFormContext<Category>()

  const { isSuperCategory, image } = useWatch({ control })
  const img = image

  const handleImageRemove = () => {
    setValue('image', undefined)
  }

  // Picking deprecated values
  useEffect(() => {
    const values = getValues()
    console.log('values', values)

    if (!values?.translations?.title?.en && values.title) {
      setValue('translations.title.en', values.title)
    }
    if (!values?.translations?.title?.fi && values.titleFI) {
      setValue('translations.title.fi', values.titleFI)
    }
    if (!values?.translations?.title?.sv && values.titleSE) {
      setValue('translations.title.sv', values.titleSE)
    }

    if (!values?.translations?.description?.en && values.description) {
      setValue('translations.description.en', values.description)
    }
    if (!values?.translations?.description?.fi && values.descriptionFI) {
      setValue('translations.description.fi', values.descriptionFI)
    }
    if (!values?.translations?.description?.sv && values.descriptionSE) {
      setValue('translations.description.sv', values.descriptionSE)
    }
  }, [])

  return (
    <Stack spacing={2}>
      {isSuperCategory && (
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          {img ? (
            <Box
              component="img"
              src={img}
              sx={{
                maxWidth: '70%',
                width: '300px',
                height: 'auto',
                border: '5px solid',
                borderColor: 'mynt.main',
                borderRadius: '10px',
              }}
            />
          ) : (
            <Box
              sx={{
                width: '20vh',
                height: '20vh',
                maxWidth: '30vw',
                maxHeight: '30vw',
                border: '5px solid',
                borderColor: 'mynt.main',
                borderRadius: '10px',
                bgcolor: 'grey.300',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="button">No image</Typography>
            </Box>
          )}
          {errors.image && errors.image.message && (
            <Typography variant="subtitle1" color="error">
              {errors.image.message as string}
            </Typography>
          )}
          <Stack direction="row" spacing={2} mt={2}>
            <Button variant="contained" component="label">
              Upload image
              <Controller
                control={control}
                name={'image'}
                render={({ field: { value, onChange, ...field } }) => {
                  return (
                    <input
                      {...field}
                      value={value?.fileName}
                      onChange={(e: any) => {
                        onChange(URL.createObjectURL(e.target.files[0]))
                      }}
                      type="file"
                      hidden
                    />
                  )
                }}
              />
            </Button>
            <Button variant="outlined" color="error" onClick={handleImageRemove}>
              Delete image
            </Button>
          </Stack>
        </Box>
      )}
      <TranslationsTable restaurant={restaurant} formBase="translations.title" title="Title" />
      <TranslationsTable restaurant={restaurant} formBase="translations.description" title="Description" optional />
      <FormControlLabel
        control={<Checkbox {...register('isSuperCategory')} defaultChecked={watch('isSuperCategory')} />}
        label="Super category"
      />
    </Stack>
  )
}

export default CategoryForm
